import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { galleryImages } from '../../data/mockData';

const GallerySection = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 3;

  const nextSlide = () => {
    setStartIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setStartIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Get visible images (3 at a time, wrapping around)
  const getVisibleImages = () => {
    const images = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (startIndex + i) % galleryImages.length;
      images.push({ ...galleryImages[index], originalIndex: index });
    }
    return images;
  };

  return (
    <section className="py-24 bg-[#0f0f12]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">
            Memories
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">
            Celebrating Leonard
          </h2>
        </div>

        <div className="relative">
          {/* Images Grid - 3 images side by side */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {getVisibleImages().map((image, index) => (
              <div
                key={`${image.originalIndex}-${index}`}
                className="aspect-[4/5] overflow-hidden rounded-lg"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors hidden md:block"
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors hidden md:block"
            aria-label="Next slide"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          {/* Mobile Navigation */}
          <div className="flex justify-center gap-4 mt-6 md:hidden">
            <button
              onClick={prevSlide}
              className="p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors"
              aria-label="Previous slide"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={nextSlide}
              className="p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors"
              aria-label="Next slide"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
